import React, { useState } from "react";
import GeniePage from "../../../components/special/genie-page/GeniePage";
import GenieText from "../../../components/core/genie-text/GenieText";
import Box from "@mui/material/Box";
import {
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import GenieStickyHeader from "../../../components/core/genie-sticky-header/GenieStickyHeader";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Product } from "../../../types/api/Product";
import InventoryDialog from "./InventoryDialog";
import { Nullable } from "../../../utils/Nullable";
import GenieEmpty from "../../../components/core/genie-empty/GenieEmpty";
import useProducts from "../../../queries/routes/useProducts";
import GenieTableLoad from "../../../components/core/genie-table-load/GenieTableLoad";

function ProductList() {
  const navigate = useNavigate();
  let { org_id } = useParams();

  // todo migrate to use this interface when we can
  const { data: products, isLoading } = useProducts(org_id!);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [inventoryProduct] = useState<Nullable<Product>>(null);

  function setClosed() {
    setDialogOpen(false);
  }

  return (
    <GeniePage noMargin>
      <InventoryDialog
        product={inventoryProduct}
        open={dialogOpen}
        setClosed={setClosed}
      />
      <GenieStickyHeader>
        <Box display={"flex"} justifyContent={"space-between"}>
          <GenieText fontSize={"medium"} fontWeight={"bold"}>
            Products
          </GenieText>
        </Box>
        <Button
          variant={"outlined"}
          component={Link}
          to={`/app/${org_id}/products/add`}
        >
          Add New Product
        </Button>
      </GenieStickyHeader>
      {isLoading ? (
        <GenieTableLoad rowCount={10} columnCount={4} />
      ) : products && products.length > 0 ? (
        <TableContainer component={Box} sx={{ mt: 4 }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Image</TableCell>
                <TableCell align="right">Product Name</TableCell>
                <TableCell align="right">Wholesale Price</TableCell>
                <TableCell align="right">Status</TableCell>
                {/*<TableCell align="right">*/}
                {/*  Inventory{" "}*/}
                {/*  <Chip*/}
                {/*    sx={{ ml: 1 }}*/}
                {/*    variant={"outlined"}*/}
                {/*    color={"warning"}*/}
                {/*    label="beta"*/}
                {/*    size="small"*/}
                {/*  />*/}
                {/*</TableCell>*/}
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    ":hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
                    cursor: "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                  onClick={() => navigate(`/app/${org_id}/products/${row.id}`)}
                >
                  <TableCell component="th" scope="row" align={"left"}>
                    <img
                      src={
                        row.media.length > 0
                          ? row.media[0].media.cloudinary_url
                          : "https://source.unsplash.com/random/130x130"
                      }
                      width={130}
                      height={130}
                      alt="Product"
                    />
                  </TableCell>
                  <TableCell align="right">{row.name}</TableCell>
                  <TableCell align="right">
                    ${row.unit_price_in_cents / 100}
                  </TableCell>
                  <TableCell align="right">
                    <Chip
                      label={row.state ? row.state.state : "null"}
                      variant="outlined"
                      color={
                        row.state && row.state.state === "Live"
                          ? "primary"
                          : "secondary"
                      }
                    />
                  </TableCell>
                  {/*<TableCell align="right">*/}
                  {/*  {row.inventory_count}*/}
                  {/*  <Tooltip title="Change Inventory">*/}
                  {/*    <IconButton*/}
                  {/*      sx={{ ml: 2 }}*/}
                  {/*      onClick={(event) => {*/}
                  {/*        event.preventDefault();*/}
                  {/*        event.stopPropagation();*/}
                  {/*        setInventoryProduct(row);*/}
                  {/*        setDialogOpen(true);*/}
                  {/*      }}*/}
                  {/*    >*/}
                  {/*      <AddBox fontSize={"small"} />*/}
                  {/*    </IconButton>*/}
                  {/*  </Tooltip>*/}
                  {/*</TableCell>*/}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <GenieEmpty>Products haven’t been added yet</GenieEmpty>
      )}
    </GeniePage>
  );
}

export default ProductList;
